import { createSelector } from "reselect";
import { getPageContent } from "./base";

const getPackages = createSelector([getPageContent], pageContent => {
  return pageContent?.packages || [];
});

export default getPackages;
